/*
 * With the release of SOH redesign we will be hitting a new endpoint: /api/v1/users/properties/list
 * All of the access logic will be determined on the server.
 */

const canAccessApplications = ({ restrictions = {} }) => {
    const hasApplicationsProperty = restrictions.hasOwnProperty('applications');
    // isAccessRestricted controls whether the application tab (in the subnav) should be  hidden or displayed
    return !hasApplicationsProperty || !restrictions.applications.isAccessRestricted;
};

const canUpdateApplications = ({ restrictions = {} }) => {
    const hasApplicationsProperty = restrictions.hasOwnProperty('applications');
    // isUpdateRestricted indicates whether the user is allowed to enable or disable applications on a listing
    return !hasApplicationsProperty || !restrictions.applications.isUpdateRestricted;
};

const canAccessPayments = () => true;

const canAccessGlobalAnalytics = ({ user }) => user.features.canAccessMainAnalytics;

const canAccessGlobalContacts = ({ user }) => user.features.canAccessMainContacts;

const canAccessBilling = ({ user }) => user.features.canAccessBilling;

const canAccessSettings = ({ user }) => user.features.canAccessMainSecuritySettings;

const canAccessUserManagement = ({ user }) => user.features.canAccessUserManagement;

const canAccessInvoicePayments = ({ user, cookieEnabledServices }) => user.features.canAccessInvoicePayments
    || cookieEnabledServices.ZG_CUSTOMER_PAYMENT_ENABLED;

const canAccessLeases = () => true;

export default {
    canAccessApplications,
    canAccessPayments,
    canAccessGlobalAnalytics,
    canAccessGlobalContacts,
    canAccessBilling,
    canAccessSettings,
    canAccessUserManagement,
    canAccessLeases,
    canUpdateApplications,
    canAccessInvoicePayments,
};
